/**
 * Level 12: Candy Kingdom
 * 
 * Sweet themed level with bouncy platforms:
 * - Colorful candy visuals
 * - Extra bouncy trampolines (gummy)
 * - Sweet-themed obstacles
 * - Fun and lighthearted atmosphere
 * 
 * @module configs/levels/Level12_CandyKingdom
 */

/** @type {import('../LevelTypes').LevelConfig} */
const Level12_CandyKingdom = {
    id: 12,
    name: 'Candy Kingdom',
    subtitle: 'Sweet Dreams',
    description: 'Bounce through a delicious candy wonderland!',
    
    worldWidth: 4200,
    worldHeight: 1600,
    playerStart: { x: 120, y: 1300 },
    gravity: 0.9,  // Slightly lighter for more bouncy feel
    
    theme: {
        bgGradient: ['#ff69b4', '#ffc0cb'],  // Pink gradient
        platformColor: 0xff6b9d,  // Candy pink
        accentColor: 0xffff00,
        particleColor: 0xff00ff
    },
    
    platforms: [
        // Lollipop entrance
        { x: 0, y: 1400, w: 350, h: 50 },
        { x: 400, y: 1250, w: 150, h: 25 },
        { x: 650, y: 1100, w: 180, h: 25 },
        
        // Gummy bear valley
        { x: 900, y: 1300, w: 280, h: 40 },
        { x: 1150, y: 1150, w: 160, h: 25 },
        { x: 1400, y: 1000, w: 180, h: 25 },
        
        // Chocolate river crossing
        { x: 1700, y: 1250, w: 300, h: 45 },
        { x: 2050, y: 1100, w: 180, h: 25 },
        { x: 2350, y: 950, w: 200, h: 30 },
        
        // Cookie crumble peaks
        { x: 2650, y: 1150, w: 250, h: 35 },
        { x: 2950, y: 1000, w: 180, h: 25 },
        { x: 3200, y: 850, w: 200, h: 25 },
        
        // Ice cream palace
        { x: 3500, y: 1100, w: 320, h: 45 },
        { x: 3850, y: 950, w: 200, h: 30 },
        { x: 4000, y: 1200, w: 250, h: 50 }
    ],
    
    movingPlatforms: [
        { x: 560, y: 1180, w: 100, h: 20, moveY: 150, speed: 0.0025 },
        { x: 1850, y: 1180, w: 120, h: 20, moveX: 160, speed: 0.003 },
        { x: 3100, y: 920, w: 110, h: 20, moveY: 120, speed: 0.002 }
    ],
    
    spikes: [
        // Careful: candy can be dangerous!
        { x: 1750, y: 1250 },
        { x: 1800, y: 1250 },
        { x: 2700, y: 1150 },
        { x: 2750, y: 1150 }
    ],
    
    stars: [
        { x: 650, y: 1000 },
        { x: 1400, y: 900 },
        { x: 2350, y: 850 },
        { x: 3200, y: 750 },
        { x: 3850, y: 850 }
    ],
    
    enemies: [
        { x: 1000, y: 1250 },
        { x: 1800, y: 1200 },
        { x: 2750, y: 1100 },
        { x: 3600, y: 1050 }
    ],
    
    door: { x: 4100, y: 1050, w: 50, h: 300 },
    button: { x: 3950, y: 1195 },
    box: { x: 3550, y: 1000, floating: false },  // Push the candy box
    goal: { x: 4150, y: 1100 },

    decorations: [
        { key: 'decor-candy', centerInLevel: true, scale: 9, alpha: 0.2, scrollFactor: 0.18, depth: -50 }
    ],
    
    // Lots of trampolines for bouncy candy fun!
    trampolines: [
        { x: 350, y: 1400, w: 80 },
        { x: 850, y: 1300, w: 80 },
        { x: 1650, y: 1250, w: 80 },
        { x: 2600, y: 1150, w: 80 },
        { x: 3450, y: 1100, w: 80 }
    ],
    
    speedrunTargets: { gold: 45, silver: 65, bronze: 85 }
};

export default Level12_CandyKingdom;
